module.exports = __webpack_public_path__ + "img/deposit@2x (2).d73d9ab7.png";